import { useState } from "react";
import type { ChangeEvent, ReactElement } from "react";
import { Button, Image, Input, message, Space, Upload } from "antd";
import type { UploadProps } from "antd";
import { upload } from "../../../api";
import { getErrorMessage } from "./goodsLabels";

interface ProductImageInputProps {
  id?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  onBusyChange: (busy: boolean) => void;
}

export function ProductImageInput({
  id,
  value,
  onChange,
  disabled,
  onBusyChange,
}: ProductImageInputProps): ReactElement {
  const [uploading, setUploading] = useState(false);
  const imageUrl = value?.trim();
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange?.(event.target.value);
  };
  const handleUpload: UploadProps["customRequest"] = async (options) => {
    setUploading(true);
    onBusyChange(true);
    try {
      const response = await upload(options.file);
      if (typeof response.data !== "string" || !response.data.trim())
        throw new Error("上传未返回图片地址，请重试");
      onChange?.(response.data.trim());
      options.onSuccess?.(response);
    } catch (error: unknown) {
      const uploadError = new Error(getErrorMessage(error));
      void message.error(uploadError.message);
      options.onError?.(uploadError);
    } finally {
      setUploading(false);
      onBusyChange(false);
    }
  };
  return (
    <Space direction="vertical" size={8} style={{ width: "100%" }}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          id={id}
          value={value}
          onChange={handleChange}
          disabled={disabled || uploading}
          placeholder="上传图片或输入图片地址"
        />
        <Upload
          accept="image/*"
          showUploadList={false}
          disabled={disabled || uploading}
          customRequest={handleUpload}
        >
          <Button disabled={disabled} loading={uploading}>
            上传图片
          </Button>
        </Upload>
      </Space.Compact>
      {imageUrl && (
        <Image
          src={imageUrl}
          alt="图片预览"
          width={96}
          height={96}
          style={{ objectFit: "contain", border: "1px solid #e8edf2", borderRadius: 6 }}
          preview={{ mask: "预览" }}
        />
      )}
    </Space>
  );
}
